import hj from '@hotjar/browser'

const actions = {
  identify: (userId: string, userProperties = {}) => {
    if (userId) {
      hj.identify(userId, userProperties)
    }
  },
  track: (eventName: string) => {
    if (eventName) {
      hj.event(eventName)
    }
  },
}

export const HotJar = actions
